"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const sales_api_service_1 = require("../../../shared/api/sales-api.service");
const config_service_1 = require("../../../shared/config/config.service");
const toast_service_1 = require("../../../ui-components/toast/toast.service");
const vehicle_1 = require("../shared/models/vehicle/vehicle");
const vehicle_export_service_1 = __importDefault(require("../shared/services/export/vehicle-export.service"));
let VehicleExportComponent = class VehicleExportComponent {
    constructor(vehicle, configService, salesApiService, vehicleExportService, toastService) {
        this.vehicle = vehicle;
        this.configService = configService;
        this.salesApiService = salesApiService;
        this.vehicleExportService = vehicleExportService;
        this.toastService = toastService;
        this.dataCount = 0;
        this.sending = false;
        this.getCount = () => __awaiter(this, void 0, void 0, function* () {
            const DELIMITER = ', ';
            let filter = {};
            const filters = [];
            if (this.options.make)
                filters.push({ 'modelData.make': { $in: this.options.make.split(DELIMITER) } });
            if (this.options.model)
                filters.push({ 'modelData.model': { $in: this.options.model.split(DELIMITER) } });
            if (this.options.location)
                filters.push({ 'vehicleData.inventory.location': { $in: this.options.location.split(DELIMITER) } });
            if (this.options.availability)
                filters.push({ 'vehicleData.availability.code': { $in: this.options.availability.split(DELIMITER) } });
            if (this.options.vehicleType)
                filters.push({ 'vehicleData.availability.state': { $in: this.options.vehicleType.split(DELIMITER) } });
            if (this.options.inventoryState)
                filters.push({ 'vehicleData.inventory.state': { $in: this.options.inventoryState.split(DELIMITER) } });
            if (this.options.stockOnDay) {
                /**
                 * Include vehicles, that have a `costs.invoiceDate` <= `stockOnDay`
                 * but no `sellData.invoiceDate` or `sellData.invoiceData` > `stockOnDay`
                 */
                filters.push({ 'vehicleData.costs.invoiceDate': { $lte: this.options.stockOnDay } });
                filters.push({
                    $or: [
                        { 'vehicleData.availability.sellData.handoverDate': { $exists: false } },
                        { 'vehicleData.availability.sellData.handoverDate': { $gt: this.options.stockOnDay } }
                    ],
                });
            }
            if (this.options.orderDateFrom)
                filters.push({ 'vehicleData.order.orderDate': { $gte: this.options.orderDateFrom } });
            if (this.options.orderDateUntil)
                filters.push({ 'vehicleData.order.orderDate': { $lte: this.options.orderDateUntil } });
            filter = { $and: filters };
            if (!filters.length) {
                this.dataCount = 0;
                return null;
            }
            const count = yield this.salesApiService.getExportCount(filter);
            this.dataCount = count;
            return filter;
        });
        this.exportSelection = () => __awaiter(this, void 0, void 0, function* () {
            const filter = yield this.getCount();
            if (!filter)
                return;
            this.sending = true;
            this.vehicle.getAll(filter)
                .then((vehicles) => {
                if (!vehicles.length) {
                    this.sending = false;
                    return;
                }
                this.vehicleExportService.exportCsv(vehicles, 'erweiterter-export');
                this.sending = false;
            })
                .catch((e) => {
                console.error(e);
                this.toastService.toast(toast_service_1.ToastType.ERROR, 'Fehler beim Exportieren.');
                this.sending = false;
            });
        });
        this.options = {
            availability: '',
            inventoryState: '',
            location: '',
            make: '',
            model: '',
            orderDateFrom: null,
            orderDateUntil: null,
            stockOnDay: null,
            vehicleType: '',
        };
        this.filterTranslations = {
            vehicleType: this.configService.get('sales_car_types'),
            availability: this.configService.getConstant(config_service_1.ConstantTypes.AVAILABILITY),
            inventoryState: this.configService.getConstant(config_service_1.ConstantTypes.INVENTORY_STATE),
            locations: this.configService.get('general_locations'),
        };
    }
};
VehicleExportComponent = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-export',
        templateUrl: require('./vehicle-export.component.html'),
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof vehicle_1.Vehicle !== "undefined" && vehicle_1.Vehicle) === "function" ? _a : Object, typeof (_b = typeof config_service_1.ConfigService !== "undefined" && config_service_1.ConfigService) === "function" ? _b : Object, typeof (_c = typeof sales_api_service_1.SalesAPIService !== "undefined" && sales_api_service_1.SalesAPIService) === "function" ? _c : Object, typeof (_d = typeof vehicle_export_service_1.default !== "undefined" && vehicle_export_service_1.default) === "function" ? _d : Object, typeof (_e = typeof toast_service_1.ToastService !== "undefined" && toast_service_1.ToastService) === "function" ? _e : Object])
], VehicleExportComponent);
exports.default = VehicleExportComponent;
